<div id="main" [class]="'theme-wrapper ' + (selectedTheme$ | async)">
  <app-emergency-alert [alertMessages]="emergencyAlerts() || []" />
  <app-main-menu>
    <router-outlet />
  </app-main-menu>
  <app-floating-feedback-button />
</div>
